import { memo, useRef } from 'react'
import { Fab, useTheme, styled } from '@mui/material'
import { WebliteAddIcon } from '@weblite/icons'
import { openContacts } from '$logic/router'
import { HotSpot } from '$common/tour/components/hot-spot'
import { useOnboarding } from '$logic/onboarding/react-hooks'
import { CommonOnboarding } from '$logic/onboarding/types'

export const CreateRoomFab = memo(() => {
  const theme = useTheme()
  const ref = useRef<HTMLButtonElement>(null)
  const { enabled: onboardingEnabled, completeOnboarding } = useOnboarding(
    CommonOnboarding.CREATE_ROOM_FAB,
  )
  return (
    <StyledFab
      ref={ref}
      color="neutral"
      onClick={() => {
        completeOnboarding()
        void openContacts()
      }}
    >
      {onboardingEnabled && (
        <HotSpot
          sx={{ position: 'absolute', top: '-4px', right: '-4px' }}
          containerRef={ref}
        />
      )}
      <WebliteAddIcon
        primaryColor={theme.palette.neutral000}
        secondaryColor={theme.palette.neutral700}
      />
    </StyledFab>
  )
})

const StyledFab = styled(Fab)`
  position: absolute;
  bottom: 12px;
  left: 12px;
  border-radius: 16px;
`
